import { render } from "./Chevron.vue?vue&type=template&id=42f1e61d"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Chevron.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42f1e61d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42f1e61d', __exports__)) {
    api.reload('42f1e61d', __exports__)
  }
  
  module.hot.accept("./Chevron.vue?vue&type=template&id=42f1e61d", () => {
    api.rerender('42f1e61d', render)
  })

}


export default __exports__